<template>
  <v-content>
    <div class="display-2 text-center">404</div>
    <div class="display-1 text-center primary--text">Oh!</div>
    <div class="headline text-center">Looks like this page doesn't exist</div>
    <v-row>
      <v-spacer></v-spacer>
      <img :src="require('@/assets/logo.svg')" class="mx-auto" contain height="350" width="250" />
      <v-spacer></v-spacer>
    </v-row>
    <div class="text-center">
      <v-btn class="primary" :to="{ name: 'Campaign' }">Get me Out of Here</v-btn>
    </div>
  </v-content>
</template>

<script>
export default {
  metaInfo: { title: "Oops! No Page Found" },
};
</script>

<style>
</style>